import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Input } from "components/ui/input";
import { Button } from "components/ui/button";
import { ChevronLeft } from "lucide-react";
import Select from "../components/generic/Select";

export default function SignupPageCrew() {
  const navigate = useNavigate();
  const [workingDistance, setWorkingDistance] = useState("");

  const distanceOptions = [
  { value: "Upto 10 miles", label: "Upto 10 miles" },
  { value: "Upto 25 miles", label: "Upto 25 miles" },
  { value: "Upto 50 miles", label: "Upto 50 miles" },
  { value: "I'm open to travelling", label: "I'm open to travelling" },
  ];

  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    location: "",
    working_distance: "",
    profile_picture: null,
  });

  // High-quality video from public folder
  const videoSrc = "/videos/signup-video.mp4";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fdf9f2] relative px-4">

      {/* LOGO */}
      <div className="absolute top-1 left-12 z-20">
        <img
          src="/images/Container.png"
          alt="Logo"
          className="w-24 h-24 object-contain"
        />
      </div>

      {/* BACKGROUND IMAGE */}
      <div
        className="absolute top-0 left-0 w-full h-full bg-cover bg-center"
        style={{ backgroundImage: "url('/images/LoginBg.png')" }}
      />

      {/* MAIN CARD */}
      <div className="relative z-10 max-w-6xl w-full bg-white rounded-2xl shadow-xl overflow-hidden flex">

        {/* LEFT SIDE — FORM */}
        <div className="w-full lg:w-1/2 flex flex-col p-10 overflow-y-auto max-h-[90vh] no-scrollbar">

          {/* BACK BUTTON */}
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-gray-500 text-sm mb-4"
          >
            <ChevronLeft size={18} className="mr-1" /> Back
          </button>

          {/* TITLE */}
          <p className="text-sm text-gray-500 mb-1">Step 1/3</p>

          <h2 className="text-3xl font-bold text-gray-900">
            Build Your Creative Profile
          </h2>

          <p className="text-gray-500 text-sm mb-6">
            Create your profile to get discovered by production teams.
          </p>

          {/* FORM FIELDS */}
          <div className="space-y-5 pb-10">

            {/* NAME */}
            <div className="flex gap-4">
              <div className="w-1/2">
                <label className="text-sm font-medium mb-1 block">First Name</label>
                <Input
                  placeholder="John"
                  value={form.first_name}
                  onChange={(e) =>
                    setForm({ ...form, first_name: e.target.value })
                  }
                />
              </div>

              <div className="w-1/2">
                <label className="text-sm font-medium mb-1 block">Last Name</label>
                <Input
                  placeholder="Doe"
                  value={form.last_name}
                  onChange={(e) =>
                    setForm({ ...form, last_name: e.target.value })
                  }
                />
              </div>
            </div>

            {/* EMAIL */}
            <div>
              <label className="text-sm font-medium mb-1 block">Email Address</label>
              <Input
                type="email"
                placeholder="you@example.com"
                value={form.email}
                onChange={(e) =>
                  setForm({ ...form, email: e.target.value })
                }
              />
            </div>

            {/* PASSWORD */}
            <div>
              <label className="text-sm font-medium mb-1 block">Password</label>
              <Input
                type="password"
                placeholder="Create a password"
                value={form.password}
                onChange={(e) =>
                  setForm({ ...form, password: e.target.value })
                }
              />
            </div>

            {/* LOCATION */}
            <div>
              <label className="text-sm font-medium mb-1 block">Location</label>
              <Input
                placeholder="Add Your Location"
                value={form.location}
                onChange={(e) =>
                  setForm({ ...form, location: e.target.value })
                }
              />
            </div>

            {/* WORKING DISTANCE */}
            <div>
              <label className="text-sm font-medium mb-1 block">Working Distance</label>
              <Select
                id="working_distance"
                options={distanceOptions}
                placeholder="Select working distance"
                value={workingDistance}
                onChange={setWorkingDistance}
              />
            </div>

            {/* PROFILE PICTURE */}
            <div>
              <label className="text-sm font-medium mb-1 block">Profile Picture</label>

              <div className="flex items-center gap-3">
                {form.profile_picture ? (
                  <img
                    src={URL.createObjectURL(form.profile_picture)}
                    alt="Profile"
                    className="w-14 h-14 rounded-full object-cover"
                  />
                ) : (
                  <div className="w-14 h-14 rounded-full bg-gray-200" />
                )}

                <label className="cursor-pointer border px-4 py-2 rounded-lg text-sm bg-gray-50 hover:bg-gray-100">
                  Upload Profile Picture
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={(e) =>
                      setForm({ ...form, profile_picture: e.target.files[0] })
                    }
                  />
                </label>
              </div>
            </div>

            {/* NEXT BUTTON */}
            <Button className="w-full bg-black text-white py-3 mt-4">
              Next
            </Button>

            {/* FOOTER */}
            <p className="text-center text-sm text-gray-500 mt-4 mb-6">
              Already have an account?{" "}
              <Link to="/login" className="text-black font-medium hover:underline">
                Log in
              </Link>
            </p>
          </div>
        </div>

        {/* RIGHT SIDE — HIGH QUALITY VIDEO */}
        <div className="hidden lg:flex w-1/2 relative">
          <video
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src={videoSrc} type="video/mp4" />
          </video>
        </div>

      </div>
    </div>
  );
}
